import camelize from 'fbjs/lib/camelize';

const storageKey = 'debug';
const appName = camelize(process.env.REACT_APP_NAME);

window.debug = function() {
  return Function.prototype;
};

const namespace = getNamespace();

if (namespace) {
  setup(window, [groupedOutput]);
} else {
  const onStorageHandler = (event) => {
    if (event.key === storageKey) {
      setup(window, [groupedOutput]);
      window.removeEventListener('storage', onStorageHandler);
    }
  };

  window.addEventListener('storage', onStorageHandler);
}

function getNamespace() {
  try {
    return localStorage.getItem(storageKey);
  } catch (e) {
    return false;
  }
}

/**
 * Very similar approach used in Embed, it's time to pick out this one in separated package.
 * It also need to keep in mind that current 4.1.1 debug version are broken and not compatible with IE.
 */

function setup(ctx = window, patches = []) {
  const module = require('debug');

  if (!ctx.console) {
    return;
  }

  patches.forEach(patch => patch(ctx, module));

  ctx.debug = (...debugIds) => {
    const logName = [appName, ...debugIds].filter(Boolean).join(':');
    return module(logName);
  };
}

/**
 * Monkey patch original debug, include trace into output
 * TODO: It's time to fork that project
 */
function groupedOutput(ctx, module) {
  if (ctx.console.trace && ctx.console.groupCollapsed) {
    module.log = function(...args) {
      console.groupCollapsed(...args);
      console.trace();
      console.groupEnd();
    };
  }
}
